import { useTranslation } from 'react-i18next';
import { LiliTextArea, Text } from '@lili/lili-frontend-common';
import { ControllerWrapper } from '@Hooks/index';
import { EddEmbeddedFields } from '@Pages/happyFlowPages/eddQuestions/pages/embedded/fields.types';

export const NonprofitDescriptionDForm = () => {
  const { t } = useTranslation('eddQuestions');

  return (
    <div className='flex flex-col gap-[16px] mt-[16px]'>
      <Text.H9>{t('organic.nonprofitDescriptionD.question')}</Text.H9>

      <ControllerWrapper name={EddEmbeddedFields.EDD_NONPROFIT_DESCRIPTION_D}>
        {({ onChange, value, error, onBlur }) => (
          <LiliTextArea
            value={value}
            onValueChange={onChange}
            errorMsg={error?.message || ''}
            externalErrorMessage={error?.message || ''}
            maxLength={300}
            minHeight='min-h-[120px]'
            placeholder={t('organic.nonprofitDescriptionD.placeholder')}
            onBlur={onBlur}
          />
        )}
      </ControllerWrapper>
    </div>
  );
};
